export const API_URL = process.env.REACT_APP_API_URL as string
export const CF_API_URL = process.env.REACT_APP_CF_API_URL as string
export const FLOW_API_URL = process.env.REACT_APP_FLOW_API_URL as string
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PK as string
export const BUILD_NUMBER = (process.env.REACT_APP_BITBUCKET_BUILD_NUMBER as string) || 'dev'
export const GOOGLE_OAUTH_CLIENT_ID = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID as string
export const defaultUtmSource = 'platform'
